import React from 'react';
import { Helmet } from 'react-helmet-async';
// import MainSearch from '../../components/MainSearch/MainSearch';
// import SliderPromo from '../../components/SliderPromo/SliderPromo';
import OfertasDestacadas from '../../components/OfertasDestacadas/OfertasDestacadas';
// import Services from '../../components/Services/Services';
// import { Promos } from '../../components/Promos/Promos';
import CarouselHome from '../../components/Carousel/Carousel';


const Home = () => {
  return (
    <>
      <Helmet>
        <title>Click Hogar - Mueblería y Artículos del Hogar en Bahía Blanca</title>
        <meta name="description" content="Mueblería y artículos del hogar en Bahía Blanca. Cocinas a medida, línea blanca, colchones, bicicletas y más. Envíos gratis en Bahía Blanca. Garantía y servicio post venta." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://clickhogarbahia.com.ar/" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Click Hogar",
            "url": "https://clickhogarbahia.com.ar",
            "logo": "https://clickhogarbahia.com.ar/logo512.png",
            "description": "Mueblería y artículos del hogar en Bahía Blanca. Cocinas a medida, línea blanca, colchones, bicicletas y más.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Brasil 978",
              "addressLocality": "Bahía Blanca",
              "addressRegion": "Buenos Aires",
              "postalCode": "8000",
              "addressCountry": "AR"
            },
            "sameAs": [
              "https://www.facebook.com/clickhogarbahia"
            ]
          }
        `}</script>
      </Helmet>
      <h1 className="sr-only">Click Hogar - Mueblería y Artículos del Hogar en Bahía Blanca</h1>
      <CarouselHome />
      <OfertasDestacadas />
      {/* <MainSearch /> */}
      {/* <Promos /> */}
      {/* <SliderPromo /> */}
      {/* <Services /> */}
    </>
  );
};

export default Home;
